export const features = [
  {
    title: '海量内容资源',
    description: '平台汇聚百万级优质内容，涵盖多元领域，持续更新扩充，满足各类用户的内容消费需求。',
    icon: 'ri-database-2-line',
    imageSeq: 'feature-content',
    imageQuery: 'Abstract data library visualization with warm orange nodes, floating document icons, minimalist modern design, cream background with soft gradient, professional clean aesthetic',
  },
  {
    title: '智能精准推荐',
    description: '基于先进算法的个性化推荐引擎，精准分析用户偏好，智能匹配兴趣内容，提升内容发现效率。',
    icon: 'ri-brain-line',
    imageSeq: 'feature-recommend',
    imageQuery: 'Abstract AI brain network visualization, warm orange neural connections, minimalist technology aesthetic, cream background, floating data points, modern clean design',
  },
  {
    title: '多端无缝访问',
    description: '支持网页端、移动端、平板等多设备访问，数据实时同步，随时随地畅享内容服务。',
    icon: 'ri-device-line',
    imageSeq: 'feature-multi-device',
    imageQuery: 'Multiple devices showing synchronized content interface, warm orange accent, minimalist modern composition, cream background, clean product photography style with soft shadows',
  },
  {
    title: '严格安全防护',
    description: '多层安全防护体系，包括数据加密传输、账号保护机制和内容安全审核，全方位保障用户权益。',
    icon: 'ri-shield-keyhole-line',
    imageSeq: 'feature-security',
    imageQuery: 'Abstract security shield concept with warm orange glow, lock symbols floating around, minimalist design, cream background, modern professional aesthetic, editorial quality',
  },
  {
    title: '优质用户体验',
    description: '简洁直观的界面设计，流畅的操作体验，持续优化的交互细节，让内容消费成为享受。',
    icon: 'ri-emotion-happy-line',
    imageSeq: 'feature-ux',
    imageQuery: 'Abstract user experience concept with warm orange interface elements, minimalist design, smooth curved lines, cream background, modern clean aesthetic, soft gradient lighting',
  },
  {
    title: '专业客服支持',
    description: '7×24小时专业客服团队，多渠道快速响应，为用户提供及时、高效的问题解决方案。',
    icon: 'ri-customer-service-2-line',
    imageSeq: 'feature-support',
    imageQuery: 'Abstract customer support concept, warm orange chat bubble icons, minimalist modern design, cream background, interlocking geometric shapes, professional editorial illustration',
  },
];

export const usageSteps = [
  {
    step: '01',
    title: '访问官方网站',
    description: '通过浏览器访问91.cn com官方网站，使用正确的官方入口链接。',
    icon: 'ri-global-line',
  },
  {
    step: '02',
    title: '注册个人账号',
    description: '点击注册按钮，填写基本信息完成账号注册，并进行邮箱或手机验证。',
    icon: 'ri-user-add-line',
  },
  {
    step: '03',
    title: '浏览发现内容',
    description: '通过分类导航、搜索或智能推荐，浏览和发现感兴趣的内容。',
    icon: 'ri-compass-3-line',
  },
  {
    step: '04',
    title: '享受内容服务',
    description: '选择喜欢的内容进行查看和使用，享受平台提供的各类内容服务。',
    icon: 'ri-play-circle-line',
  },
];